import { useId, type ReactNode } from 'react';
import styles from './TenantPreviewPane.module.css';

interface TenantPreviewPaneProps {
  title: string;
  description: string;
  children: ReactNode;
}

export const TenantPreviewPane = ({ title, description, children }: TenantPreviewPaneProps) => {
  const headingId = useId();

  return (
    <section className={styles.tenantPreviewPane} aria-labelledby={headingId}>
      <h2 id={headingId}>{title}</h2>
      <p>{description}</p>
      {children}
    </section>
  );
};
